
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","fill-rule":"evenodd","d":"M8.978 7.256l.025.043.027.05 1.57 3.082.032-.045c.24-.334.656-.56 1.129-.59l.062-.004h.052c.326 0 .635.092.885.255l.053.037.014.01.003-.008c.189-.394.576-.67 1.027-.707l.052-.003.05-.001c.296 0 .576.105.795.286l.043.037.008.008.006-.01c.145-.205.35-.364.592-.453l.056-.02.05-.014c.632-.169 1.284.177 1.502.79l.016.045.014.05.459 1.713V17.5H8.123l-.178-.002-.143-.003-.137-.005c-1.12-.048-1.623-.297-1.623-1.032 0-.81.766-1.334 1.874-1.439l.066-.005.088-.006.01-.003.022-.004.023-.001h1.998L6.8 8.48l-.023-.047c-.276-.607-.025-1.326.571-1.63.581-.296 1.289-.095 1.629.453zM3.75 10.833c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm3.129.554l.991 1.945c-.669-.024-1.203-.574-1.203-1.249 0-.258.078-.497.212-.696zM3.75 6.667c.69 0 1.25.56 1.25 1.25s-.56 1.25-1.25 1.25-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm8.333 0c.69 0 1.25.56 1.25 1.25 0 .102-.012.202-.035.297-.284.078-.55.204-.787.372l-.026.02-.084-.017c-.172-.031-.348-.047-.526-.047h-.07l-.042.002-.085.004-.078.006c-.154.015-.307.041-.455.08l-.05.013-.23-.452c-.02-.09-.032-.183-.032-.278 0-.69.56-1.25 1.25-1.25zM3.75 2.5C4.44 2.5 5 3.06 5 3.75S4.44 5 3.75 5 2.5 4.44 2.5 3.75 3.06 2.5 3.75 2.5zm4.167 0c.69 0 1.25.56 1.25 1.25S8.607 5 7.917 5s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25zm4.166 0c.69 0 1.25.56 1.25 1.25S12.773 5 12.083 5s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25z"}})])
          )
        }
      }
    